/* card/types */
import * as t from "io-ts";
import {DataCodec as PosSoftwareDataCodec} from "../possoftware/types";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AttributeCodec = t.type({
  FileName: t.string,
  Data: t.string
})

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);


export type Data = t.TypeOf<typeof DataCodec>;

export const TerminalBackgroundCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "PosCodec"
);


export type TerminalBackground = t.TypeOf<typeof TerminalBackgroundCodec>;

export enum TerminalBackgroundTypes {
  FETCH = "@@terminalBackground/FETCH",
  FETCH_SUCCESS = "@@terminalBackground/FETCH_SUCCESS",
  FETCH_ERROR = "@@terminalBackground/FETCH_ERROR",
  SAVE_REQUEST = "@@terminalBackground/SAVE_REQUEST",
  SAVE_SUCCESS = "@@terminalBackground/SAVE_SUCCESS",
  SAVE_ERROR = "@@terminalBackground/SAVE_ERROR",
  DELETE_REQUEST = "@@terminalBackground/DELETE_REQUEST",
}

export interface TerminalBackgroundState {
  readonly loading: boolean;
  readonly data: any;
  readonly errors?: string;
}
